import script from "./BaseCustomModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseCustomModal.vue?vue&type=script&setup=true&lang=ts"

import "./BaseCustomModal.vue?vue&type=style&index=0&id=6f7f5f98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f7f5f98"]])

export default __exports__